// @ts-nocheck
/* eslint-disable */

"use client";

import {
  BlogCard,
  Button,
  Column,
  Icon,
  RichText,
  Row,
  Spacer,
} from "tempdev-ds";

import { BlocksProps } from "@/lib/wordpress/_types/blocksStyle";
import DisplayImage from "@/components/common/DisplayImage/DisplayImage";
import Link from "next/link";
import displayBlock from "@/lib/wordpress/blocks/displayBlock";
import { formatDate } from "@/lib/helpers/dateFormate";
import { styled } from "styled-components";
import { useGlobalContext } from "@/lib/globalContext";

const StyledLink = styled(Link)`
  display:block;
  border:1px solid;
  border-color: ${(props) => (props.color ? props.color : "inherit")};
  padding: 16px;
  border-radius: 8px;

  transition: all 0.3s ease;

  &:hover{
    color: white;
    background-color: ${(props) => (props.color ? props.color : "inherit")};
  }
`;

const ServicesPost = (post: Record<string, unknown>) => {
  const state = useGlobalContext();

  return (
    <div>
      <Spacer height={6} />

      <Row>
        <Column md={12}>
          <Button
            variant="link"
            href="/services/"
            leftIcon={<Icon icon="icon-arrow-back"></Icon>}
            className="mb-4"
          >{state?.dict?.custom?.backServices}</Button>
        </Column>
      </Row>

      {!!(post?.blocks as [])?.length && (
        <>
          <Row>
            <Column md={12}>
              <div className="w-100 radius-sm radius-md-md p-5" style={{ backgroundColor: post?.category?.acf?.color_medium }}>
                {(post?.blocks as []).map((block: BlocksProps, index: number) => {
                  return displayBlock(block, index);
                })}
              </div>
            </Column>
          </Row>
          <Spacer height={8} />
        </>
      )}

      {post?.posts && post?.posts?.items && (
        <Row>
          <Column lg={1}></Column>
          <Column lg={10}>
            <Row fluid={true}>
              {post?.posts?.items?.map(item => {
                return (
                  <Column key={`service-${item?.slug}`} lg={4} className="text-center mb-6">
                    <DisplayImage
                      url={item?.acf?.icon as string}
                      alt={item?.title ? (item?.title as string) : ""}
                      width={75}
                      height={75}
                      className="m-auto"
                    />
                    <StyledLink color={post?.category?.acf?.color_strong} href={item.slug} className="h5 w-100 mt-3">{item.title}</StyledLink>
                    {typeof item.excerpt === "string" && (
                      <RichText tag="p" className="mt-4">{item.excerpt}</RichText>
                    )}
                  </Column>
                )
              })}
            </Row>
          </Column>
          <Column lg={1}></Column>
        </Row>
      )}

      {post?.acf && post?.acf?.related_posts && (
        <div className="w-100 pt-6 pb-6 mt-5" style={{ background: post?.category?.acf?.color_medium }}>
          <Row>
            <Column>
              <span class="sc-grXZZQ bwuLqq color-gray50 fw-semibold text-uppercase mb-4">{state?.dict?.custom?.fromBlog}</span>
            </Column>
            {post?.acf?.related_posts?.map((item, i) => {
              return (
                <Column key={`post-${i}`} lg={3} className="">
                  <BlogCard
                    variant={"sm"}
                    date={formatDate(item?.date as string, 'DATE_SHORT')}
                    imageElement={
                      <DisplayImage
                        url={item?.image as string}
                        alt={item?.title ? (item?.title as string) : ""}
                        fill={true}
                      />
                    }
                    title={item?.title}
                    description={item?.excerpt}
                    linkElement={
                      <Link
                        href={item?.slug as string}
                        className="linker"
                      ></Link>
                    }
                  />
                </Column>
              )
            })}
          </Row>
        </div>
      )}

      {!!(post?.extraContent?.blocks as [])?.length &&
        (post?.extraContent?.blocks as []).map((block: BlocksProps, index: number) => {
          return displayBlock(block, index);
        })}

      <Spacer height={8} />
    </div>
  );
};
export default ServicesPost;
